import { Injectable, inject } from "@angular/core";
import { of, forkJoin } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { LorenAutomationPlanService } from "../services/loren-automation-plan-service/loren-automation-plan.service";
import { LorenAuthenticationService } from "../../../shared/services/loren-authentication-service/loren-authentication.service";
import { LorenGeofencingCircleService } from "../../loren-geofencing/services/loren-geofencing-circle-service/loren-geofencing-circle.service";
import { LorenGeofencingPolygonService } from "../../loren-geofencing/services/loren-geofencing-polygon-service/loren-geofencing-polygon.service";
import { LorenAssetService } from "../../loren-assets/services/loren-asset-service/loren-asset.service";

@Injectable()
export class LorenAllAutomationPlansResolver {
  private service = inject(LorenAutomationPlanService);
  private authenticationService = inject(LorenAuthenticationService);
  private geofenceCircleService = inject(LorenGeofencingCircleService);
  private geofencePolygonService = inject(LorenGeofencingPolygonService);
  private assetService = inject(LorenAssetService);


  resolve() {
    const userId = this.authenticationService.getUserInfo().id;
    const requests = [
      this.service.getAllPlans(userId),
      this.geofenceCircleService.query(),
      this.geofencePolygonService.query(),
      this.assetService.query(),
    ] as const;

    return forkJoin(requests).pipe(
        map(([plans, circles, polygons, assets]) => {
          return {
            entities: plans.items,
            geozones: [...circles.items, ...polygons.items],
            assets: assets.items,
            error: null,
          };
        }),
      catchError((err) =>
        of({ entities: null, geozones: null, assets: null, error: err })
      )
    );
  }
}
